import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/broken")({
  component: BrokenComponent,
});

function BrokenComponent(): never {
  throw new Error(
    "This page intentionally throws an error to test the error boundary UI.",
  );
}
